import { render, staticRenderFns } from "./FileAdd.vue?vue&type=template&id=4cc54c02&"
import script from "./FileAdd.vue?vue&type=script&lang=js&"
export * from "./FileAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports